import React from "react";
import landingVideo from "@/assets/landing-video.mp4";

const Index = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center overflow-hidden">
      <video
        src={landingVideo}
        autoPlay
        muted
        loop
        playsInline
        className="min-w-full min-h-full w-auto h-auto object-cover"
      />
    </div>
  );
};

export default Index;
